import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { getArrowStylesBySize } from '@elliemae/ds-popper/getArrowStylesBySize';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ArrowWrapper = aggregatedClasses('span')('popover', 'arrow');

function Arrow(_ref) {
  var style = _ref.style,
      className = _ref.className,
      innerRef = _ref.innerRef;
      _ref.blockName;
      var placement = _ref.placement,
      otherProps = _objectWithoutProperties(_ref, ["style", "className", "innerRef", "blockName", "placement"]);

  return /*#__PURE__*/React.createElement(ArrowWrapper, _extends({
    className: className,
    "data-placement": placement
  }, otherProps, {
    innerRef: innerRef,
    style: _objectSpread(_objectSpread({}, style), getArrowStylesBySize(placement, 25))
  }), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26 C26.7,29,24.6,28.1,23.7,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"
  })));
}

var Arrow$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Arrow, _extends({}, props, {
    innerRef: ref || props.innerRef
  }));
});

export default Arrow$1;
//# sourceMappingURL=Arrow.js.map
